import React from 'react';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
 
export class MapContainer extends React.Component {
    render() {
      return (
        <Map google={this.props.google} zoom={14} style={{color:"white"}}>
   
          <Marker onClick={this.onMarkerClick}
                  name={'Current location'} />
   
          <InfoWindow onClose={this.onInfoWindowClose}>
              <div>
                <h1>Dhaka</h1>
              </div>
          </InfoWindow>
        </Map>
      );
    }
  }
 
export default GoogleApiWrapper(
    (props) => ({
      apiKey: "AIzaSyC7rdcOGqFvHt4eCXUOKJ_LyNLCblhNJSY"
      
    }
  ))(MapContainer)
  